import React, { Component } from 'react';
import './App.css';
import Video from  './video';
import Header from './header';
import ChannelList from './channelList';
import thunk from 'redux-thunk';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import rootReducer from './reducers/index';
import TagManager from 'react-gtm-module'
import ChannelListDesktop from './channelListDesktop';


const tagManagerArgs = {
  gtmId: 'GTM-5T8GMJS'
}

TagManager.initialize(tagManagerArgs);

const createScript=(url) => {
  const script = document.createElement("script");
  script.src = url;
  script.async = true;
  document.body.appendChild(script);
}

let store = createStore(
  rootReducer,
  applyMiddleware(thunk)
)
class App extends Component {
  componentWillMount(){
     createScript("https://www.gstatic.com/cv/js/sender/v1/cast_sender.js?loadCastFramework=1");
  }
  windowWidth(){
    return window.innerWidth;
  }
  render() {
    return (
      <Provider store={store}>
        <div className="App">
          <Header></Header>
          <div className="video-playlist">
            <Video className="video-container"></Video>
            <ChannelList className="channel-list-container" channels={store.getState().channelList}/>
          </div>
        </div>
      </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js